export default "__VITE_ASSET__1460eae3__"